module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp23_9005.ca24945b.png";